import { gql } from '@apollo/client';

export const MESSAGE_FIELDS = gql`
  fragment MessageFields on Message {
    id
    value
    source
    sourceId
    createdAt
    updatedAt
    userId
    targetUserId
    parentMessageId
    reactions
    author {
      displayName
      gravatarHash
    }
    messageContexts {
      name
      value
      document {
        id
        path
      }
    }
  }
`;
